import { render, staticRenderFns } from "./NativeContextualCampaignEdit.vue?vue&type=template&id=22a18e20&scoped=true"
import script from "./NativeContextualCampaignEdit.vue?vue&type=script&lang=js"
export * from "./NativeContextualCampaignEdit.vue?vue&type=script&lang=js"
import style0 from "../../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./NativeContextualCampaignEdit.vue?vue&type=style&index=1&id=22a18e20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a18e20",
  null
  
)

export default component.exports